import React from 'react';
import { styled } from '@linaria/react';
import { useTheme, ITheme } from 'src/theme';
import Icon1 from '@assets/icon/health-cio-chief-information-officer-badge.svg';
import Icon2 from '@assets/icon/receive-money-quickly-badge.svg';
import Icon3 from '@assets/icon/me-and-someone-else-badge.svg';
import Icon4 from '@assets/icon/specialist-care-and-treatment-badge.svg';
import Icon6 from '@assets/icon/pennies-for-good-badge.svg';

const Container = styled.div<{ theme: ITheme }>`
	margin-top: 30px;
	flex-direction: row;
	box-sizing: border-box;
	display: flex;
	place-content: flex-start center;
	align-items: flex-start;
	width: 100%;
	@media screen and (max-width: 767px) {
		flex-wrap: wrap;
	}
`

const ColWrap = styled.div`
	flex-flow: column wrap;
	box-sizing: border-box;
	display: flex;
	place-content: stretch flex-start;
	align-items: stretch;
	max-width: 100%;
`;

const Item = styled.div<StyledProps>`
	flex-direction: row;
	display: flex;
	place-content: stretch flex-start;
	align-items: stretch;
	box-sizing: border-box;
	flex: 1 1 100%;
	max-width: 28%;
	margin-bottom: 30px;
	margin-right: 11px;
`;

const Img = styled.img<StyledProps>`
	width: 64px;
	height: 64px;
  position: relative;
  @media screen and (min-width: 768px) {
    height: 64px;
  }
  @media screen and (min-width: 1024px) {
    height: 64px;
  }
`;

const ImageContainer = styled.div`
	flex-flow: row wrap;
	box-sizing: border-box;
	display: flex;
	place-content: stretch center;
	align-items: stretch;
	max-height: 100%;
`;

const Text = styled.div<StyledProps>`
	flex-flow: row wrap;
	box-sizing: border-box;
	display: flex;
	place-content: stretch center;
	align-items: stretch;
	max-height: 100%;
	text-align: center;
	font-size: 16px;
	color: ${props => props.theme.colors.grey[500]};
`;

interface StyledProps {
	theme: ITheme,
}

export interface BenefitListProps {
	theme?: ITheme,
}

function BenefitList({ }: BenefitListProps) {
	const theme = useTheme();

	return (
		<Container theme={theme}>
			<Item theme={theme}>
				<ColWrap>
					<ImageContainer><Img theme={theme} src={Icon1}></Img></ImageContainer>
					<Text theme={theme}>Aids to help daily living</Text>					
				</ColWrap>
			</Item>
			<Item theme={theme}>
			<ColWrap>
				<ImageContainer><Img theme={theme} src={Icon2}></Img></ImageContainer>
					<Text theme={theme}>Everyday living expenses</Text>
					</ColWrap>
			</Item>
			<Item theme={theme}>
				<ColWrap>
				<ImageContainer><Img theme={theme} src={Icon3}></Img></ImageContainer>
					<Text theme={theme}>Care-giver expenses</Text>
					</ColWrap>
			</Item>
			<Item theme={theme}>
				<ColWrap>
				<ImageContainer><Img theme={theme} src={Icon4}></Img></ImageContainer>
				<Text theme={theme}>Medication and therapy</Text>
				</ColWrap>
			</Item>
			<Item theme={theme}>
				<ColWrap>
				<ImageContainer><Img theme={theme} src={Icon6}></Img></ImageContainer>
				<Text theme={theme}>Miscellaneous expenses</Text>
				</ColWrap>
			</Item>
		</Container>

	);
};

BenefitList.defaultProps = {
}

export default BenefitList;
